import angular from 'angular';

import AccessDeniedComponent from './access-denied.component';

const AccessDeniedModule = angular
    .module('control-room.commons.layout.components.access-denied', [])
    .component('crAccessDenied', AccessDeniedComponent);

export default AccessDeniedModule;
